import { createIcon } from '../utils';

export const BillingIndicatorIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.3327 15.0013L14.9993 16.668L18.3327 13.3346M18.3327 8.33464H1.66602M18.3327 10.0013V6.83464C18.3327 5.90122 18.3327 5.43451 18.151 5.07799C17.9912 4.76438 17.7363 4.50941 17.4227 4.34963C17.0661 4.16797 16.5994 4.16797 15.666 4.16797H4.33268C3.39926 4.16797 2.93255 4.16797 2.57603 4.34962C2.26243 4.50941 2.00746 4.76438 1.84767 5.07798C1.66602 5.4345 1.66602 5.90121 1.66602 6.83464V13.168C1.66602 14.1014 1.66602 14.5681 1.84767 14.9246C2.00746 15.2382 2.26243 15.4932 2.57603 15.653C2.93255 15.8346 3.39926 15.8346 4.33268 15.8346H9.99935"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'BillingIndicatorIcon', defaultSize: 20 },
);
